var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.state.otherRoof)?_c('OtherMeshKit'):(_vm.$store.state.type === 'Solar Panel')?_c('MeshKitSolarPanel'):_c('MeshKit')],1)}
var staticRenderFns = []

export { render, staticRenderFns }